import TiremetrixErrorsHtml from './tiremetrix.errors.html';

export function TiremetrixErrors () {
  return {
    restrict: 'E',
    templateUrl: TiremetrixErrorsHtml,
    scope: {
      data: '=',
      id: '@'
    },
    link: function (scope, element, attrs) {
      scope.type = 'error';

      scope.dismissedOn = localStorage[scope.id + '_notifications_dismissed_on'];

      scope.dismissed = function () {
        if (!scope.dismissedOn) {
          return false;
        }

        var createdOn   = moment(scope.data[0].created_on);
        var dismissedOn = moment(scope.dismissedOn);

        return dismissedOn.isAfter(createdOn);
      };

      scope.dismiss = function () {
        scope.dismissedOn = moment().toISOString();
        localStorage[scope.id + '_notifications_dismissed_on'] = scope.dismissedOn;
      }
    }
  };
}